const materialSelectMixin = {
    data() {
        return {
            menuFetchFunc: {
                image: this.fetchMaterial,
                posters: this.fetchMaterial
            }
        };
    },
    computed: {
        materialMaxLevel() {
            // return this.isYX ? 2 : 1;
            return 2;
        }
    },
    methods: {
        getMixedProps(type) {
            if (!this.isYX && type === 'image') {
                return {
                    menu: [
                        {
                            key: 'image',
                            label: this.$t('图片')
                        }
                    ],
                    createNodeUrl: '/mp/imgMaterial',
                    fetchAtOnce: false
                };
            }
            if (!this.isYX && type === 'article') {
                return {
                    createNodeUrl: '/mp/imgTxtMaterial/single',
                    fetchAtOnce: false,
                    search: '' // 屏蔽查询功能
                };
            }
            if (this.isYX && type === 'image') {
                return {
                    menu: [
                        {
                            key: 'image',
                            label: this.$t('图片'),
                            search: this.$t('图片名称')
                        }
                    ]
                };
            }
            return {};
        },
        fetchMaterial(params, _this) {
            const that = this;
            if (params.level === '0' && !params.searchKey) {
                const groupUrl = that.getGroupUrl(params);
                return that.$ajax.get(groupUrl, { params: { type: params.type } }).then(res => {
                    if (res.code === 0) {
                        if (that.isYX) {
                            // 素材的其他分组
                            if (res.data.records) {
                                res.data.records.forEach(item => {
                                    item.level = 1;
                                    item.label = item.name;
                                });
                            }
                        } else {
                            if (res.data) {
                                res.data.forEach(item => {
                                    item.level = 1;
                                    item.label = item.name;
                                });
                            }
                        }
                    }
                    return that.isYX ? {
                        options: res.data.records || res.data.groups || [],
                        total: res.data.total || 0
                    } : {
                        options: res.data || [],
                        total: res.data.length || 0
                    };
                });
            }
            const materialUrl = that.getMaterialUrl(params);
            const queryParams = this.getQueryParams(params);
            return that.$ajax
                .get(materialUrl, { params: queryParams })
                .then(res => {
                    const result = that.isYX ? res.data : res;
                    if (_this.props && _this.props(_this).formatterResult) {
                        _this.props(_this).formatterResult(result);
                    }
                    // 对客服数据做转换处理
                    const records = result && result.records ? result.records : [];
                    const total = result && result.total ? result.total : 0;
                    if (!this.isYX) {
                        // 客服场景需要兼容数据格式
                        that.formatterVSResult(records, params.materialType);
                    }
                    return {
                        options: records,
                        total
                    };
                })
                .catch(() => ({
                    options: [],
                    total: 0
                }));
        },
        getQueryParams(params) {
            if (this.isYX) {
                const result = {
                    count: params.count,
                    groupId: params.id,
                    status: params.status,
                    index: params.page,
                    name: '',
                    keyword: params.searchKey || undefined
                };
                // 文本类型时，如果设定支持查询变量文本，修改filterType和type的属性值
                if (params.materialType === 'text') {
                    if (this.showParamTexts === true) {
                        // 查询带变量
                        result.filterType = '';
                        result.type = 1;
                    } else {
                        // 查询不带变量文本
                        result.filterType = 1;
                        result.type = '';
                    }
                }
                // 图文类型时，如果设定支持查询多图文，修改filterType和type的属性值
                if (params.materialType === 'article') {
                    if (this.showMultiImgText === true) {
                        // 查询多图文+单图文
                        result.filterType = 1;
                        result.type = '';
                    } else {
                        result.filterType = ''; // 查询单图文
                        result.type = 1; // 查询单图文
                    }
                }
                if (params.materialType === 'image') {
                    result.filterType = 1;
                    result.type = '';
                }
                return result;
            }
            return {};
        },
        // 获取分组地址
        getGroupUrl(params) {
            const that = this;
            if (!that.isYX) {
                if (params.materialType === 'article') {
                    return `/mp/materialGroup/list?index=1&count=100&groupType=imgTxt`;
                }
                return `/mp/materialGroup/list?index=1&count=100&groupType=image`;
            }
            return params.url;
        },
        // 获取资源地址
        getMaterialUrl(params) {
            const that = this;
            if (!that.isYX) {
                if (params.materialType === 'article') {
                    const imgTxtType = this.showMultiImgText ? 0 : 1;
                    return `/mp/rest/imgTxtMaterial?count=${params.count}&index=${params.page}&imgTxtType=${imgTxtType}&groupId=${params.id}`;
                }
                return `/mp/rest/imgMaterial?index=${params.page}&count=${params.count}&groupId=${params.id}`;
            }
            return params.url;
        },
        formatterVSResult(records, materialType) {
            if (materialType === 'article') {
                records.forEach(record => {
                    const titleArray = [];
                    record.articles
                        && record.articles.forEach(article => {
                            if (!article.cover && article.showUrl) {
                                article.cover = article.showUrl;
                            }
                            titleArray.push(article.title);
                        });
                    if (!record.title) {
                        record.title = titleArray.join(',');
                    }
                });
            } else if (materialType === 'image') {
                records.forEach(record => {
                    if (!record.imageUrl && record.showUrl) {
                        record.imageUrl = record.showUrl;
                    }
                    if (!record.title) {
                        record.title = record.name;
                    }
                });
            }
        }
    }
};

export default materialSelectMixin;
